export default "__VITE_ASSET__DVjqUlbl__"